export const defaults = {
    nodeWidth: 300,
    nodeHeight: 75,
    nodePortHeight: 20,
    paperMarginX: 50,
    paperMarginY: 50,
    nodeSep: 50,
    paperScaleX: 0.8,
    paperScaleY: 0.8,
    graphRankDir: 'LR',
    graphRanker: 'network-simplex',
    graphAlign: 'UL',
    linkRouter: 'metro',
    linkTooltipOffset: 10,
    elementsBorderRadius: 5,
    elementFill: '#f8f9fa',
    elementPassiveBorderColor: '#6c757d',
    elementTextColor: '#6c757d',
    elementActiveBorderColor: '#343a40',
    linkPassiveColor: '#CCCCCC',
    linkActiveColor: '#ffc107',
    paperBackgroundColor: '#ffffff',
    elementPassiveStrokeWidth: 1,
    elementActiveStrokeWidth: 3,
    linkPassiveStrokeDasharray: 5.5,
    portRadius: 7.5,
    portSelfRadius: 5,
    floatingBoxFontSize: 14,
    floatingBoxPadding: 20,
    floatingBoxHeight: 40,
    floatingBoxMinWidth: 100,
    paperBorderColor: '#dddddd'
}